export function sortByName (sortOrder = 'asc', locale = navigator.language) {
  return (a, b) => {
    if (sortOrder === 'asc') {
      return a.name?.localeCompare(b.name, locale) ?? 0
    } else {
      return b.name?.localeCompare(a.name, locale) ?? 0
    }
  }
}

export function sortResultsBy (
  sortBy = DEFAULT_SORT_BY,
  locale = navigator.language
) {
  switch (sortBy) {
    case 'NAME_ASC':
      return sortByName('asc', locale)
    case 'NAME_DESC':
      return sortByName('desc', locale)
    default:
      return sortByName('asc', locale)
  }
}

export const DEFAULT_SORT_BY = 'NAME_ASC'

export const DEFAULT_SORT_BY_OPTIONS = {
  NAME_ASC: {
    label: 'common.librarySorting.nameAsc'
  },
  NAME_DESC: {
    label: 'common.librarySorting.nameDesc'
  }
}

/**
 * @description Creates a comparator function that sorts items based on their index in a given priority order.
 * @param {string} field - The field to compare.
 * @param {Array} orderedValues - An array defining the order of priority for the field values.
 * @returns {function} A comparator function that can be used with array sorting methods.
 * @example
 * const exampleValues = ['high', 'medium', 'low'];
 * const comparator = sortByPrioritisedFieldValues('exampleField', exampleValues);
 * const sortedItems = items.sort(comparator);
 */
export const sortByPrioritisedFieldValues = (field, orderedValues) => (a, b) => {
  const aIndex = orderedValues.indexOf(a[field])
  const bIndex = orderedValues.indexOf(b[field])

  if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex
  if (aIndex !== -1) return -1
  if (bIndex !== -1) return 1
  return 0 // No priority difference
}
